import { Component, OnInit } from '@angular/core';
import { AbstractService } from "@services/abstract.service";

@Component({
  template: ''
})
export abstract class AbstractSelect implements OnInit {
  public abstract list: any[];
  public abstract selectTemporal: any[];

  constructor(
    public service: AbstractService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  public loadData = () => {
    this.list = [];
    this.service.getAll().then(
      (data) => {
        if (data === true) {
          this.list = this.service?.data.data;
        }
      }
    );
  }

  public onKey(e: any, key: string) {
    const filter = e.target.value.toLowerCase();
    if (this.selectTemporal === undefined || this.selectTemporal.length === 0) { this.selectTemporal = this.list; }
    if (key === '') {
      this.list = this.selectTemporal.filter(i => {
        return i.toLowerCase().includes(filter)
      });
    } else {
      this.list = this.selectTemporal.filter(i => {
        return i[key].toLowerCase().includes(filter)
      });
    }
  }
}
